import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthRedirectService } from '../../auth/auth-redirect.service';
import { UserManager } from '../../auth/user-manager';
import { AuthUserService } from '../../init/auth-user.service';
import { NavbarActiveElectionService } from 'src/app/core/navbar/navbar-active-election.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.less'],
  standalone: false
})
export class NavbarComponent implements OnInit, AfterViewInit, OnDestroy {

  @Output()
  onViewInit: EventEmitter<any> = new EventEmitter();

  username: string = '';
  activeElectionCount = 0;

  sub1: Subscription | null = null;

  constructor(
    private authUserService: AuthUserService,
    private authRedirectService: AuthRedirectService,
    private navbarActiveElectionService: NavbarActiveElectionService,
  ) {
    if (this.authUserService.isAnonymous) {
      this.username = 'Visitante';
    } else {
      const user = this.authUserService.getCurrentUser();
      this.username = (!user.isAnonymous ? user.username : null)
        ?? UserManager.getUserInfo()?.username
        ?? 'Usuário';
    }
  }

  get isAnonymous(): boolean {
    return this.authUserService.isAnonymous;
  }

  ngOnDestroy(): void {
    this.sub1?.unsubscribe();
  }

  ngOnInit() {
    if (this.isAnonymous) {
      this.activeElectionCount = 0;
      return;
    }

    this.sub1 = this.navbarActiveElectionService.getActiveElectionCount().subscribe((count: number) => {
      this.activeElectionCount = count;
    });

    this.navbarActiveElectionService.refreshActiveElectionCount();
  }

  refreshActiveElectionCount(): void {
    this.navbarActiveElectionService.refreshActiveElectionCount();
  }

  public logout() {
    this.authRedirectService.logout();
  }

  ngAfterViewInit(): void {
    this.onViewInit.emit();
  }
}
